
    import Vue from "vue";

    const END_POINT = "/manage-pages";

    const getMyAccountPages = () => Vue.axios.get(END_POINT + "/my-pages" );

    const getAvailablePages = () => Vue.axios.get(END_POINT + "/available-pages" , {params: {pageIndex: 0, size: 1000}});

    const getPage2Roles = async () => {
        const result = await Vue.axios.get("/role-page" )
            .then( (resp) => {
                const list = resp.data;
                if(list){
                    return list.reduce( (map, i) => {
                        if(map[i.pageId]){
                            map[i.pageId].push(i.role);
                        }
                        else{
                            map[i.pageId] = [i.role];
                        }
                        return map;
                    } , {});
                }
                else{
                    return {}
                }
            })
            .catch( (error) => {
                console.warn(error.data)
                return [];
            })
            
        return result;
    }

    const deletePage = (pageId) => Vue.axios.delete("/account-page/" + pageId);

    const addPage = (pageId, sequence) => {
        const data = {
            pageId,
            sequence
        }
        return Vue.axios.post("/account-page", data);
    }

    const updateRoles = (pageId, roles) => {
        const data = {
            roles
        }
        return Vue.axios.put("/role-page/update/"+pageId, data);
    }

    const updatePageLabel = (pageId, label) => {
        const data = {
            overrideLabel: label
        }
        return Vue.axios.put("/account-page/"+pageId, data);
    }

    export {
        getAvailablePages,
        getMyAccountPages,
        getPage2Roles,
        deletePage,
        addPage,
        updateRoles,
        updatePageLabel
    };
    